import { render, staticRenderFns } from "./HorizontalTitleListGraphql.vue?vue&type=template&id=455d42fd&scoped=true&"
import script from "./HorizontalTitleListGraphql.vue?vue&type=script&lang=ts&"
export * from "./HorizontalTitleListGraphql.vue?vue&type=script&lang=ts&"
import style0 from "./HorizontalTitleListGraphql.vue?vue&type=style&index=0&id=455d42fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455d42fd",
  null
  
)

export default component.exports